import sdl from '@jds/react-generated-sdl/JDSTableCell';
import type { JDSTableCellProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSTableCellProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    type = 'cell',
    density = 'relaxed',
    background = false,
    columnDivider = false,
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { type, density, background, columnDivider, ...rest },
    'JDSTableCell',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const TableCell = withLogic(Component) as React.FC<JDSTableCellProps> & {
  slotName?: string;
};

TableCell.displayName = 'TableCell';
TableCell.slotName = 'jds_table_cell';

export { TableCell, type JDSTableCellProps };
